export default {
  namespaced: true,
  state() {
    return {
      ads: [],
    };
  },
  getters: {
    getAdById: (state) => (id) => state.ads.find((ad) => ad.id === id),
    isAdMounted: (state) => (id) => state.ads.find((ad) => ad.id === id)?.isAdMounted,
  },
  mutations: {
    adMounted(state, id) {
      const adFound = state.ads.find((ad) => ad.id === id);
      if (!adFound) {
        state.ads.push({
          id,
          isLoaded: false,
          isAdMounted: true,
        });
      } else {
        adFound.isAdMounted = true;
      }
    },
    pushAdData(state, id) {
      if (!state.ads.find((ad) => ad.id === id)) {
        state.ads.push({
          id,
          isLoaded: false,
          isAdMounted: false,
        });
      }
    },
    adLoaded(state, id) {
      state.ads.find((ad) => ad.id === id).isLoaded = true;
    },
    removeAdLoaded(state) {
      state.ads.forEach((ad) => {
        ad.isLoaded = false;
      });
    },
    removeAdMounted(state, id) {
      const adFound = state.ads.find((ad) => ad.id === id);
      if (adFound) adFound.isAdMounted = false;
    },
  },
  actions: {
    adMounted({ commit }, id) {
      commit('adMounted', id);
    },
    pushAdData({ commit }, id) {
      commit('pushAdData', id);
    },
    setAdLoaded({ commit }, id) {
      commit('adLoaded', id);
    },
    removeAdLoadedOnFacetSelection({ commit }) {
      commit('removeAdLoaded');
    },
    removeAdMountedOnFacetSelection({ commit }, id) {
      commit('removeAdMounted', id);
    },
  },
};
